import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { CardHeader, CardTitle, CardDescription } from "../ui/card";

/**
 * Component for workspace and repository selection
 */
const WorkspaceSelector = ({
  workspaces,
  selectedWorkspace,
  onWorkspaceChange,
  repositories,
  selectedRepository,
  viewAllRepos,
  onRepositoryChange,
}) => {
  return (
    <CardHeader className="pb-3">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <CardTitle>Pipeline Status</CardTitle>
          <CardDescription>
            View running and failed pipelines that need attention
          </CardDescription>
        </div>

        <div className="mt-4 md:mt-0 flex flex-col sm:flex-row gap-3">
          <div className="w-64">
            <Select value={selectedWorkspace} onValueChange={onWorkspaceChange}>
              <SelectTrigger id="workspace" className="w-full h-9">
                <SelectValue placeholder="Select Workspace" />
              </SelectTrigger>
              <SelectContent>
                {workspaces.map((workspace) => (
                  <SelectItem key={workspace.slug} value={workspace.slug}>
                    {workspace.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="w-64">
            <Select
              value={viewAllRepos ? "__all__" : selectedRepository}
              onValueChange={onRepositoryChange}
              disabled={!selectedWorkspace}
            >
              <SelectTrigger id="repository" className="w-full h-9">
                <SelectValue placeholder="Select Repository" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">All Repositories</SelectItem>
                {repositories.map((repo) => (
                  <SelectItem key={repo.slug} value={repo.slug}>
                    {repo.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </CardHeader>
  );
};

export default WorkspaceSelector;
